import React from 'react';
import {Card} from "../components/Card";
import {NavLink} from "react-router-dom";
import {Changelog} from "../components/Changelog";
import {SimulationRequestJson} from "../business/ApiJsonTypes";
import {Protected} from "../layout/Protected";


interface SimulationCriteriaExample {
    name: string,
    criteria: SimulationRequestJson
}

const examples: SimulationCriteriaExample[] = [
    // {
    //
    //     name: "Typowa udana symulacja wirnika wraz z mechaniką",
    //     criteria: {
    //         fanSelectionCriteria: {
    //             airDensity: 1.115,
    //             airFlow: 35,
    //             airflowRelativeClutchMountingSide: "CLUTCH_ON_INLET",
    //             bladeAngle: null,
    //             bladeManufacturingTypeCode: "standard",
    //             bladeProfileNames: [],
    //             crosswind: null,
    //             diffuser: null,
    //             fanApplicationTypeId: "AIR_COOLER_HEAT_EXCHANGER",
    //             fanMountingOrientation: "HORIZONTAL",
    //             impellerDiameter: 2772,
    //             impellerHeight: null,
    //             inletShapeId: "straight-cyliner",
    //             inletTemperature: 25,
    //             operationalSetupId: "INDUCED_DRAFT",
    //             preferredConstructionMaterialCode: "HDG",
    //             preferredFastenersMaterialCode: "HDG",
    //             rotationalSpeed: 200,
    //             shaftDiameter: null,
    //             shaftLength: null,
    //             staticPressure: null,
    //             staticPressureSubject: "INSTALLATION",
    //             supportAndClutchDiscSide: "SUPPORTS_AND_CLUTCH_OPPOSITE_SIDES",
    //             inletObstacle: null,
    //             outletObstacle: null,
    //             bladeTipClearancePercent: 0.5,
    //             softStartPresent: false,
    //             supportAndDiscSideChangeAllowed: true
    //         },
    //         simulationFanAdjustmentReference: {
    //             adjustableImpellerId: "wirnik-wielomianowy-demo-3",
    //             bladeAngle: 19.1
    //         }
    //     }
    // },
    // {
    //     name: "Brak rozwiązania mechanicznego (długość wału zadana: 1000mm)",
    //     criteria: {
    //         fanSelectionCriteria: {
    //             "airDensity": 1.115,
    //             "airFlow": 17,
    //             "airflowRelativeClutchMountingSide": "CLUTCH_ON_INLET",
    //             "bladeAngle": null,
    //             "bladeManufacturingTypeCode": "standard",
    //             "bladeProfileNames": [],
    //             "crosswind": null,
    //             "diffuser": null,
    //             "fanApplicationTypeId": "AIR_COOLER_HEAT_EXCHANGER",
    //             "fanMountingOrientation": "HORIZONTAL",
    //             "impellerDiameter": 2772,
    //             "impellerHeight": null,
    //             "inletShapeId": "straight-cyliner",
    //             "inletTemperature": 25,
    //             "operationalSetupId": "INDUCED_DRAFT",
    //             "preferredConstructionMaterialCode": "HDG",
    //             "preferredFastenersMaterialCode": "HDG",
    //             "rotationalSpeed": 200,
    //             "shaftDiameter": null,
    //             "shaftLength": 1000,
    //             "staticPressure": null,
    //             "staticPressureSubject": "INSTALLATION",
    //             "supportAndClutchDiscSide": "SUPPORTS_AND_CLUTCH_OPPOSITE_SIDES",
    //             "inletObstacle": null,
    //             "outletObstacle": null,
    //             "bladeTipClearancePercent": 0.5,
    //             "softStartPresent": false,
    //             supportAndDiscSideChangeAllowed: true
    //         },
    //         simulationFanAdjustmentReference: {
    //             "adjustableImpellerId": "wirnik-wielomianowy-demo-3",
    //             "bladeAngle": 12
    //         }
    //     }
    // }
];

/* TODO [
{
    name: "Typowa udana symulacja wirnika Demo-4 przy 2800mm i 150 RPM dla wydajności 25 m/s",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [],
        housingDiameter: 2800,
        impellerDiameter: 2795,
        requestedAirFlow: 25,
        requestedImpellerHeight: 99,
        requestedShaftDiameter: 38,
        requestedShaftLength: 38,
        rpm: 150,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    }
},
{
    name: "Przykład całkowicie błędnej symulacji - wirnik większy niż obudowa",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [],
        housingDiameter: 2800,
        impellerDiameter: 3000,
        requestedAirFlow: 25,
        requestedImpellerHeight: 140,
        requestedShaftDiameter: 38,
        requestedShaftLength: 80,
        rpm: 150,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    },
},
{
    name: "Zysk ciśnienia na przykładzie podstawowym przez dodanie dyfuzora kąt=8,5 H/D=0,2",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [
            "dyfuzor-8.5-0.2"
        ],
        housingDiameter: 2800,
        impellerDiameter: 2795,
        requestedAirFlow: 25,
        requestedImpellerHeight: 140,
        requestedShaftDiameter: 38,
        requestedShaftLength: 80,
        rpm: 150,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    }
},
{
    name: "Strata ciśnienia wywołana przeszkodą",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [
            "przeszkoda-za-aprzacal0.22-hd-0.24"
        ],
        housingDiameter: 2800,
        impellerDiameter: 2795,
        requestedAirFlow: 25,
        requestedImpellerHeight: 140,
        requestedShaftDiameter: 38,
        requestedShaftLength: 80,
        rpm: 150,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    }
}
,
{
    name: "Podwójny czynnik korygujący ciśnienie - przeszkoda i stożkowy kształt wlotu",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [
            "przeszkoda-za-aprzacal0.22-hd-0.24",
            "stozek-hd0.15"
        ],
        housingDiameter: 2800,
        impellerDiameter: 2795,
        requestedAirFlow: 25,
        requestedImpellerHeight: 140,
        requestedShaftDiameter: 38,
        requestedShaftLength: 80,
        rpm: 150,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    }
},
{
    name: "Dobór nieudany przez przekroczenie dozwolonej prędkości łopaty zdefiniowanej ustawieniami profilu",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [],
        housingDiameter: 2800,
        impellerDiameter: 2795,
        requestedAirFlow: 25,
        requestedImpellerHeight: 140,
        requestedShaftDiameter: 38,
        requestedShaftLength: 80,
        rpm: 600,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    }
},
{
    name: "Brak możliwości konstrukcji mechanicznej wentylatora - nietypowa średnica wału 41mm",
    criteria: {
        airDensity: 1.25,
        coolingCellArea: 20,
        correctorIds: [],
        housingDiameter: 2800,
        impellerDiameter: 2795,
        requestedAirFlow: 25,
        requestedImpellerHeight: 140,
        requestedShaftDiameter: 41,
        requestedShaftLength: 80,
        rpm: 150,
        selectedAngle: 20.1,
        selectedImpellerId: "wirnik-wielomianowy-demo-4",
        bladeManufacturingType: "standard",
        preferredFastenersMaterialCode: "HDG",
        preferredConstructionMaterialCode: "HDG",
        inletObstacleParameters: null,
        outletObstacleParameters: null,
        diffuserDetails: null,
        crosswindDetails: null
    }
},
];*/


export function SimulationExamplesPage(props: any) {
    return <Protected privilege={"PERM_DEVELOPMENT_TOOLS"}>
        <>


        <Card header={"Historia wersji"} subHeader={""} additionalClassNames={"mb-3"}>


            {/*PROBLEMY
            - ***sypie sie gyd nie ma danych, nic na wynikach zlzoenia wirnika
            - super brudny log gdy importujemy wielomiaony
            - na tablicy wentechu rozbic raprot kelnczara z wielomionych na wiele zadan
            - nie zdayzlem zaadresowac mini zadan
            - plik estymat naprezen nalezy dodac do referencyjnych!
            -0 wgrywanie estymat naprezen ze zlymi kolumnami nie pokazuje przy nieodgadniecu w xls mozliwosci estymat!! tj jakby tylko inne pliki rozponawal
            */}

            <Changelog/>

        </Card>



        <Card header="Symulacje - Katalog przykładów" subHeader={"Celem storny jest umożliwienie obserwacji przykładów bez znajomości wartości szeregu kryteriów jakie trzeba zadać do uzyskania konkretnego przypadku doboru."} additionalClassNames={"mb-3"}>
            {examples.map(example => <div>

                <NavLink to={"/simulation?b64Criteria=" +btoa(JSON.stringify(example.criteria))} className={"btn btn-sm btn-primary me-3"}><i className="fas fa-chart-line"></i> Symuluj</NavLink>
                {example.name}
                <div className="separator my-5"></div>
            </div>)}
        </Card>

    </>;
    </Protected>
}

SimulationExamplesPage.propTypes = {}

SimulationExamplesPage.defaultProps = {}
